export default "/static/dashboard/build/app/img/v2/1b9256557a06b638ddcff687e0f98286.png";